import Button from '../../Button'
import { Header } from '../../Modal'
import Box from '../../Modal/Box'
import Buttons from '../../Modal/Buttons'
import { Content } from '../../Modal/Content'
import { Container } from '../Container'

function ModalSizeM({ children }) {
  return (
    <Container label='Modal, size M - 464px, max height - 560px'>
      <Box size='m'>
        <Header text='Header text' />
        <Content size='m'>{children}</Content>
        <Buttons size='m'>
          <Button.Contained text='Save' />
          <Button.Outlined text='Cancel' />
        </Buttons>
      </Box>
    </Container>
  )
}

export default ModalSizeM
